import React from "react";

import {RouterProvider} from "react-router-dom";
import {easasMainRouter} from "./routes";

const EasasMain = () => {
    return (
        <RouterProvider router={easasMainRouter} future={{ v7_startTransition: true }} />
    );
}


export default EasasMain;